import { MobileKalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile';
import { KalenderWeekPicker } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/KalenderWeekPicker';
import {
  faFilter,
  faLayerGroup,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/SortierungButton';
import {
  Button,
  Badge,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui';
import { useState } from 'react';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter';
import { Uebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Uebersicht';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';

/* eslint-disable max-lines-per-function */
export function MobilePage({ view }: { view: string }) {
  const [kalenderFilterOptionsVisible, setKalenderFilterOptionsVisible] =
    useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    store: {
      ui: {
        kalender: { filter: kalenderFilter },
        uebersicht: { filter: uebersichtFilter },
      },
      setKalenderView,
    },
  } = useRotationsplanFeatureContext();

  let selectedFilterCount = 0;
  if (view === 'planung') {
    Object.values(kalenderFilter).forEach((filter) => {
      if (filter.length > 0) {
        selectedFilterCount += 1;
      }
    });
  } else {
    Object.values(uebersichtFilter).forEach((filter) => {
      if (filter.length > 0) {
        selectedFilterCount += 1;
      }
    });
  }

  return (
    <>
      <div className="sticky top-0 z-10 bg-white">
        <KalenderWeekPicker />
      </div>
      <Tabs
        className="p-4"
        value={view}
        onValueChange={(value) => {
          navigate(`/mitarbeiter/rotationsplaene/${value}`);
        }}>
        <div className="flex w-full justify-between">
          <TabsList className="w-full bg-neutrals-300">
            <TabsTrigger className="w-full" value="planung">
              {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
            </TabsTrigger>
            <TabsTrigger className="w-full" value="uebersicht">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="planung">
          <Tabs
            className="flex flex-col gap-4"
            defaultValue="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
            <div className="flex justify-between items-center">
              <TabsList className="bg-neutrals-300">
                <Tooltip>
                  <TooltipTrigger>
                    <TabsTrigger
                      onClick={() => setKalenderView('byArbeitsbereiche')}
                      value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                      <FontAwesomeIcon fixedWidth icon={faLayerGroup} />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachArbeitsbereichenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
                <Tooltip>
                  <TooltipTrigger
                    onClick={() => setKalenderView('byMitarbeiter')}>
                    <TabsTrigger value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                      <FontAwesomeIcon fixedWidth icon={faUserGroup} />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachMitarbeitendenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
              </TabsList>
              <div className="flex items-center gap-2">
                <Button
                  className="flex items-center gap-2"
                  variant="ghost"
                  onClick={() =>
                    setKalenderFilterOptionsVisible(
                      !kalenderFilterOptionsVisible,
                    )
                  }>
                  <FontAwesomeIcon icon={faFilter} />
                  {t('domain.mitarbeiter.rotationsplan.filter.label')}
                  <Badge type="pill" variant="secondary">
                    {selectedFilterCount}
                  </Badge>
                </Button>
                <SortierungButton />
              </div>
            </div>
            {kalenderFilterOptionsVisible && (
              <div className="flex gap-2 items-center justify-between overflow-auto">
                <BerufeFilter view={view as View} />
                <LehrjahrFilter view={view as View} />
                <StandorteFilter />
              </div>
            )}
            <TabsContent
              asChild
              value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
              <MobileKalender view="arbeitsbereiche" />
            </TabsContent>
            <TabsContent
              asChild
              value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
              <MobileKalender view="mitarbeiter" />
            </TabsContent>
          </Tabs>
        </TabsContent>
        <TabsContent className="flex flex-col gap-4" value="uebersicht">
          <Uebersicht />
        </TabsContent>
      </Tabs>
    </>
  );
}
